import { ref, set } from 'firebase/database';
import React, { useState } from 'react';
import { db } from '../firebase.init';

const Enrollment = ({ japanese,id }) => {
    const [userData, setUserData] = useState({
        name: '',
        email: '',
        course: 'JLPT study',
        num: ''
    })
    const [show, setShow] = useState(true);
    const [success,setSuccess]=useState('');
    // const [name,setName]=useState('');
    // const [email,setEmail]=useState('');
    // const [num,setNum]=useState('');

    const submitData = async (e) => {
        e.preventDefault();
        const { name, email, course, num } = userData;

        if(japanese?name===''||email===''||course===''||num==='':name===''||email===''||course===''){
            console.log(userData);
        }else{
            set(ref(db, 'mayaJapanese/' + name), {
                name, email, course, num
            })
                .then(() => {
                    setShow(true);
                    setSuccess('Enrolled successfully...Thank you.'); 
                    setTimeout(() => {
                        setShow(false);
                    }, 3000); 
                })
                .catch((error) => {
                    console.log(error);
                });
        }  
        setUserData({name:'',email:'',course:'',num:''});
    }

    const handleCancel = (e) => {
        e.preventDefault();
        setUserData({name:'',email:'',course:'',num:''})

    }
    return (
        <div className='px-5' id={id}>
            <h4 className='bg-head text-center text-white text-lg rounded-sm p-2'>Enroll Now</h4>

            <form className=' font-bold' onSubmit={submitData}>
                <p className='my-2'>Name</p>
                <input className=' rounded border-2 border-slate-400 px-2 w-full' type="text" name="" required
                    id="" value={userData.name} onChange={(e) => setUserData({ ...userData, name: e.target.value })} />

                <p className='my-2'>Email </p>
                <input className=' rounded border-2 border-slate-400 px-2 w-full ' value={userData.email} onChange={(e) => setUserData({ ...userData, email: e.target.value })} type="email" name="" id=""  required/>

                {
                    japanese && <div>
                        <p className='my-2'>Phone </p>
                        <input type="number" className=' rounded border-2 border-slate-400 px-2 w-full ' name="" id="" value={userData.num} onChange={(e) => setUserData({ ...userData, num: e.target.value })}  required/>
                    </div>
                }

                <p className='my-2'>Choose Course <select name="" id="" value={userData.course} onChange={(e) => setUserData({ ...userData, course: e.target.value })} className=' rounded border-2 border-slate-400 px-2 w-full py-1' required>
                    <option value="JLPT study" >JLPT study</option>
                    <option value="Business Japanese">Business Japanese</option>
                    <option value="Japanese Culture Center">Japanese Culture Center</option>
                    <option value="Job Support in Japan">Job Support in Japan</option>
                    <option value="Immigrate to Japan">Immigrate to Japan</option>
                    <option value="Study in Japan">Study in Japan</option>
                </select></p>

                <div className='flex justify-center items-center gap-2 mt-5 mx-auto mb-2'>
                    <input className=' bg-sky-600 cursor-pointer py-1 px-4 text-white rounded' type="submit" value="Submit"  />
                    <button type="reset" className=' bg-cancel cursor-pointer py-1 px-4  text-white rounded' onClick={handleCancel}>Cancel</button>
                </div>

                {show && <p className=' text-blue-700 text-center'>{success}</p>}
            </form>
        </div>
    );
};

export default Enrollment;